"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackPageView } from "@/utils/analytics";

export const AnalyticsWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const pathname = usePathname();

  useEffect(() => {
    const url = `${window.location.origin}${pathname}`;
    trackPageView(url, document.title);
  }, [pathname]);

  return <>{children}</>;
};
